
export const apiUrl = process.env.REACT_APP_API_URL

export function getAll() {
    return fetch(`${apiUrl}/offer`)
}
